// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_loginContainer__QNCqX {
    background-color: #495E57;
    height: 50vh;
    position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/Login/login.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".loginContainer {\n    background-color: #495E57;\n    height: 50vh;\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginContainer": `login_loginContainer__QNCqX`
};
export default ___CSS_LOADER_EXPORT___;
